var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('GovHero'),_c('GovPanel'),_c('GovSecurity'),_c('GovUses'),_c('GovCompliance'),_c('RequestDemo',{attrs:{"msg":"Government communications made modern — with security and compliance built in."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }